import React from 'react'
import DevopsBody from '../components/devops/DevopsBody'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'

const DevopsEngineer = () => {
  return (
    <div>
      <Navbar></Navbar>
      <DevopsBody></DevopsBody>
      <Footer></Footer>
    </div>
  )
}

export default DevopsEngineer
